import Content from "components/Layout/Content";
import React from "react";
import AppCard from "./AppCard";
import classes from "./styles.module.scss";
const AppsList = ({ apps, title, favorite = false }) => {
  return (
    <>
      {title && <p className={classes.title}>{title}</p>}
      <div className={classes.gridListV1}>
        {apps.map((item, index) => {
          return (
            <AppCard
              key={index}
              index={index}
              item={item}
              favorite={favorite}
              sizes="(max-width: 320px) 100vw, (max-width: 768px) 50vw, 33vw"
            />
          );
        })}
      </div>
    </>
  );
};

export default AppsList;
